/**
 * Error message strings
 */

import {
  AvailableTag,
  AvailableType,
} from '../services/store/modules/incident-report/models';

export const LIFE_THREATENING_SITUATION_MESSAGE =
  'In a life threatening situation call emergency services.';
export const AFTER_HOURS_MESSAGE =
  'Reporting an incident after working hours? Call Water Police on (08 9422 8600)';

export const PERMISSIONS_REQUIRED_MESSAGE =
  'In order to attach images to an incident, please give Deckee permission to access your camera and photo library in your phone settings.';
/**
 * Tags Definitions
 */

export const OIL_TAG: AvailableTag = {
  key: 'Oil',
  name: 'Oil',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const DIESEL_TAG: AvailableTag = {
  key: 'Diesel',
  name: 'Diesel',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const UNLEADED_TAG: AvailableTag = {
  key: 'Unleaded',
  name: 'Unleaded',
  areaKeys: ['TASMANIA'],
};

export const UNKNOWN_TAG: AvailableTag = {
  key: 'Unknown',
  name: 'Unknown',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const NAVIGATIONAL_AID_FAULTS_TAG: AvailableTag = {
  key: 'Navigational aid faults',
  name: 'Navigational aid faults',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const NAVIGATIONAL_DAMAGE_TAG: AvailableTag = {
  key: 'Navigational damage',
  name: 'Navigational damage',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const NAVIGATIONAL_HAZARDS_TAG: AvailableTag = {
  key: 'Navigational hazards',
  name: 'Navigational hazards',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const WRECKED_VESSEL_TAG: AvailableTag = {
  key: 'Wrecked vessel',
  name: 'Wrecked vessel',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const COLLISION_TAG: AvailableTag = {
  key: 'Collision',
  name: 'Collision',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const CAPSIZING_TAG: AvailableTag = {
  key: 'Capsizing',
  name: 'Capsizing',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const ON_BOARD_INJURY_TAG: AvailableTag = {
  key: 'On-board injury',
  name: 'On-board injury',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const SPEEDING_TAG: AvailableTag = {
  key: 'Speeding',
  name: 'Speeding',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};
export const NUISANCE_TAG: AvailableTag = {
  key: 'Nuisance',
  name: 'Nuisance',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};
export const DANGEROUS_BEHAVIOUR_TAG: AvailableTag = {
  key: 'Dangerous behaviour',
  name: 'Dangerous behaviour',
  areaKeys: ['WESTERNAUSTRALIA', 'TASMANIA', 'OTHER'],
};

export const GARBAGE_TAG: AvailableTag = {
  key: 'Garbage',
  name: 'Garbage',
  areaKeys: ['TASMANIA'],
};

export const SEWAGE_TAG: AvailableTag = {
  key: 'Sewage',
  name: 'Sewage',
  areaKeys: ['TASMANIA'],
};

export const ON_WATER_TAG: AvailableTag = {
  key: 'On Water',
  name: 'On Water',
  areaKeys: ['TASMANIA'],
};

export const ON_SHORELINE_TAG: AvailableTag = {
  key: 'On Shoreline',
  name: 'On Shoreline',
  areaKeys: ['TASMANIA'],
};

/**
 * Incident Report Type Definitions
 */

export const OIL_SPILL_TYPE: AvailableType = {
  key: 'Oil spill',
  availableTags: [OIL_TAG, UNLEADED_TAG, DIESEL_TAG, UNKNOWN_TAG],
};

export const FAULTS_AND_HAZARDS_TYPE: AvailableType = {
  key: 'Faults and Hazards',
  availableTags: [
    NAVIGATIONAL_AID_FAULTS_TAG,
    NAVIGATIONAL_DAMAGE_TAG,
    NAVIGATIONAL_HAZARDS_TAG,
    WRECKED_VESSEL_TAG,
  ],
};

export const CRASH_OR_ACCIDENT_TYPE: AvailableType = {
  key: 'Crash or accident',
  availableTags: [COLLISION_TAG, CAPSIZING_TAG, ON_BOARD_INJURY_TAG],
};

export const MOORINGS_TYPE: AvailableType = {
  key: 'Moorings',
  availableTags: [],
};

export const NON_COMPLIANCE_ON_THE_WATER_TYPE: AvailableType = {
  key: 'Non-compliance on the water',
  availableTags: [SPEEDING_TAG, NUISANCE_TAG, DANGEROUS_BEHAVIOUR_TAG],
};

export const POLLUTION_TYPE: AvailableType = {
  key: 'Pollution',
  areaKeys: ['TASMANIA'],
  availableTags: [GARBAGE_TAG, SEWAGE_TAG, UNKNOWN_TAG],
};

export const MARINE_FARMING_DEBRIS_TYPE: AvailableType = {
  key: 'Marine Farming Debris',
  areaKeys: ['TASMANIA'],
  availableTags: [ON_WATER_TAG, ON_SHORELINE_TAG],
};
